import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'twg-microsite.exploreGraph.title',
		defaultMessage: 'Your graph preview',
		description: 'Title for the graph preview section',
	},
	expandLabel: {
		id: 'twg-microsite.exploreGraph.expandLabel',
		defaultMessage: 'Expand graph preview',
		description: 'Accessible label for the button that expands the graph preview',
	},
	modalTitle: {
		id: 'twg-microsite.exploreGraph.modalTitle',
		defaultMessage: 'Graph explorer',
		description: 'Title for the modal dialog that contains the expanded graph explorer',
	},
	closeLabel: {
		id: 'twg-microsite.exploreGraph.closeLabel',
		defaultMessage: 'Close graph explorer',
		description: 'Accessible label for the button that closes the expanded graph explorer modal',
	},
	modalDescription: {
		id: 'twg-microsite.exploreGraph.modalDescription',
		defaultMessage:
			'Explore your graph in fullscreen. Press Escape or use the close button to return.',
		description:
			'Accessible description for the expanded graph explorer modal, announced by screen readers when the dialog opens',
	},
});
